export const adminHe = {
  "Sr": "מספר",
  "Business Name": "שם העסק",
  "Mail": "דוא״ל",
  "Phone": "טלפון",
  "Address": "כתובת",
  "BN Number": "ח״פ / עוסק מורשה",
  "Total Tons": "סך טונות",
  "Recent Activity": "פעילות אחרונה",
  "Name": "שם",
  "Email": "דוא״ל",
  "Active": "פעיל",
  "Job Title": "תפקיד",
  "Business name": "שם העסק",
  "Created Date": "תאריך יצירה",
  "Number Of Orders": "מספר הזמנות",
  "Date": "תאריך",
  "Supplier name": "שם הספק",
  "Supplier Email": "דוא״ל הספק",
  "user name (Sender)": "שם השולח",
  "customer": "לקוח",
  "order weight": "משקל ההזמנה",
  "Shared Document": "מסמך משותף",
  "Sender Name": "שם השולח",
  "Sharing Count": "מספר שיתופים",
  "User Email": "דוא״ל המשתמש",
  "Last Modified": "עודכן לאחרונה",
  "Rebar Items": "פריטי מוטות",
  "Net Items": "פריטי רשתות",
  "Cage Items": "פריטי כלונסאות",
  "Loading...": "טוען...",
  "Total Number of Users:": "מספר המשתמשים הכולל:",
  "Send Mail": "שליחת דוא״ל",
  "search here...": "חיפוש...",
  "Prev": "הקודם",
  "Next": "הבא",
  "Businesses": "עסקים",
  "Total Number of Businesses:": "מספר העסקים הכולל:",
  "search businesses...": "חיפוש עסקים...",
  "Orders": "הזמנות",
  "Total Number of Orders:": "מספר ההזמנות הכולל:",
  "Total Order Weights:": "משקל ההזמנות הכולל:",
  "(tons)": "(טונות)",
  "search orders...": "חיפוש הזמנות...",
  "Suppliers": "ספקים",
  "email": "דוא״ל",
  "search email suppliers...": "חיפוש ספקים לפי דוא״ל...",
  "WhatsApp": "וואטסאפ",
  "search WhatsApp suppliers...": "חיפוש ספקים בוואטסאפ...",
  "Live Users": "משתמשים פעילים",
  "connected": "מחוברים",
  "Users active during the last 15 minutes": "משתמשים שהיו פעילים ב־15 הדקות האחרונות",
  "Refresh": "רענון",
  "No connected users right now": "אין משתמשים מחוברים כרגע",
  "Users will appear after activity on the website.": "משתמשים יוצגו לאחר פעילות באתר.",
  "Status": "מצב",
  "User": "משתמש",
  "Contact": "פרטי קשר",
  "Company": "חברה",
  "Current page": "עמוד נוכחי",
  "Connected for": "משך החיבור",
  "Last activity": "פעילות אחרונה",
  "Online": "מחובר",
  "ID:": "מזהה:",
  "The list refreshes automatically every 30 seconds. Users are removed after 15 minutes without activity.": "הרשימה מתרעננת אוטומטית כל 30 שניות. משתמשים מוסרים לאחר 15 דקות ללא פעילות.",
  "Select date": "בחירת תאריך",
  "Free Trial Start Date": "תחילת תקופת ניסיון",
  "Free Trial End Date": "סיום תקופת ניסיון",
  "Trial Remaning Days": "ימי ניסיון שנותרו",
  "Free Trial Suppliers": "ספקים בתקופת ניסיון",
  "Link": "קישור",
  "link": "קישור",
  "Original User": "המשתמש המקורי",
  "Sign Date": "תאריך הרשמה",
  "Package": "חבילה",
  "Free Trial": "תקופת ניסיון",
  "Limited": "מוגבלת",
  "Unlimited": "ללא הגבלה",
  "Package Status": "מצב החבילה",
  "Operational": "פעילה",
  "Ceased": "מופסקת",
  "Printing Count": "מספר הדפסות",
  "Nets Pool": "מאגר רשתות",
  "Standard Nets": "רשתות סטנדרטיות",
  "Order by Popularity": "מיון לפי פופולריות",
  "Edit Text": "עריכת נתונים",
  "add new row": "הוספת שורה",
  "cancel": "ביטול",
  "save": "שמירה",
  "Steel Type": "סוג פלדה",
  "Diameter": "קוטר",
  "Select": "בחירה",
  "Special Nets": "רשתות מיוחדות",
  "Cage Pool": "מאגר כלונסאות",
  "Standard Cage": "כלונסאות סטנדרטיות",
  "Spiral Steel Type": "סוג פלדת הספירלה",
  "Spiral Wire Diameter": "קוטר חוט הספירלה",
  "Length Rebar Steel Type": "סוג פלדת מוטות האורך",
  "Length Rebar Diameter": "קוטר מוטות האורך",
  "Quantity of Length Rebars": "כמות מוטות האורך",
  "Rebars Pool": "מאגר מוטות",
  "Standard Rebars": "מוטות סטנדרטיים",
  "Edit": "עריכה",
  "delete": "מחיקה",
  "add new shape": "הוספת צורה",
  "Steel Type & Weights": "סוגי פלדה ומשקלים",
  "add new steel type": "הוספת סוג פלדה",
  "Enter diameter": "הזנת קוטר",
  "Add": "הוספה",
  "Steel Name": "שם סוג הפלדה",
  "Enter steel type name": "הזנת שם סוג הפלדה",
  "rebar diameters": "קטרי מוטות",
  "Create Bid": "יצירת הצעת מחיר",
  "Choose a Supplier": "בחירת ספק",
  "Select Supplier": "בחירת ספק",
  "Loading more...": "טוען פריטים נוספים...",
  "Order Number": "מספר הזמנה",
  "type order number": "הזנת מספר הזמנה",
  "Fees (apply on all rows)": "תוספות (לכל השורות)",
  "Order price before fees:": "מחיר ההזמנה לפני תוספות:",
  "ILS": "₪",
  "Standard Deviation": "סטייה תקנית",
  "Added:": "תוספת:",
  "Subtotal:": "סכום ביניים:",
  "Easybar fee": "עמלת איזיבר",
  "Payment Fee": "עמלת תשלום",
  "Total after payment fee:": "סך הכול לאחר עמלת תשלום:",
  "Total order": "סך ההזמנה",
  "Choose Pdf Language": "בחירת שפת PDF",
  "English": "אנגלית",
  "Hebrew": "עברית",
  "Prices Pdf": "PDF מחירים",
  "Prices Pdf Preview": "תצוגה מקדימה של מחירים",
  "Original Pdf": "PDF מקורי",
  "Original Pdf Preview": "תצוגה מקדימה של המקור",
  "Delete Supplier": "מחיקת ספק",
  "Suppliers pricing": "מחירוני ספקים",
  "Supplier Pricing": "מחירון ספק",
  "add Supplier": "הוספת ספק",
  "Supplier Name": "שם הספק",
  "Enter Supplier Name": "הזנת שם הספק",
  "Cancel": "ביטול",
  "A supplier with this name already Exist!": "כבר קיים ספק בשם זה!",
  "sr": "מספר",
  "Polygonal steel": "פלדה מצולעת",
  "8-25 mm": "8–25 מ״מ",
  "above 25 mm": "מעל 25 מ״מ",
  "Round steel": "פלדה עגולה",
  "6-12 mm": "6–12 מ״מ",
  "above 14 mm": "מעל 14 מ״מ",
  "Cuts": "חיתוכים",
  "Bending": "כיפוף",
  "Extra for": "תוספת עבור",
  "2D hoops": "חישוקים דו־ממדיים",
  "Standard nets": "רשתות סטנדרטיות",
  "Special nets": "רשתות מיוחדות",
  "bending nets": "כיפוף רשתות",
  "Symmetrical": "סימטרי",
  "standard pile": "כלונס סטנדרטי",
  "cage": "כלונס",
  "Special Pile": "כלונס מיוחד",
  "Gama Pile": "כלונס גאמה",
  "2 Tzol": "2 צול",
  "2.5 Tzol": "2.5 צול",
  "PDF (Hebrew)": "PDF בעברית",
  "Yes": "כן",
  "No": "לא",
  "existing": "קיים",
  "new": "חדש",
  "Block Users": "חסימת משתמשים",
  "Block User": "חסימת משתמש",
  "Verify Users": "אימות משתמשים",
  "Verify User": "אימות משתמש",
  "Delete Users": "מחיקת משתמשים",
  "Delete User": "מחיקת משתמש",
  "Deleting...": "מוחק...",
  "Failed to delete users.": "לא ניתן למחוק את המשתמשים.",
  "Failed to verify user.": "לא ניתן לאמת את המשתמש.",
  "Failed to block user.": "לא ניתן לחסום את המשתמש.",
  "User verified successfully.": "המשתמש אומת בהצלחה.",
  "User blocked successfully.": "המשתמש נחסם בהצלחה.",
  "Are you sure you want to permanently delete this user?": "האם למחוק את המשתמש לצמיתות?",
  "Delete users confirmation": "האם למחוק לצמיתות {{count}} משתמשים?",
  "Users verified": "{{count}} משתמשים אומתו בהצלחה.",
  "Users blocked": "{{count}} משתמשים נחסמו בהצלחה.",
  "In Review": "בבדיקה",
  "Approved": "מאושר",
  "Suspended": "מושהה",
  "Could not load connected users.": "לא ניתן לטעון משתמשים מחוברים.",
  "Just now": "כעת",
  "Minutes ago": "לפני {{count}} דקות",
  "Minutes ago_one": "לפני דקה",
  "Hours and minutes": "{{hours}} שעות ו־{{minutes}} דקות",
  "Minutes": "{{count}} דקות",
  "Under a minute": "פחות מדקה"
};
